export async function downloadBlobFromResponse(response) {
    if (response.ok) {
        const fileName = getFileNameFromResponse(response);
        const blob = await response.blob();
        downloadBlob(blob, fileName);
        return Promise.resolve(fileName);
    }
    return Promise.reject(response);
}

export async function getFileUrlFromResponse(response) {
    if (response.ok) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        return Promise.resolve(url);
    }
    return Promise.reject(response);
}

export function downloadBlob(blob, fileName) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = fileName
        a.click();
        URL.revokeObjectURL(a.href);
        a.remove();
    }
}

function getFileNameFromResponse(response) {
    const contentDisposition = response.headers.get('content-disposition');
    const filenameMatch = contentDisposition?.match(/filename[^*;=\n]*=((['"]).*?\2|[^*;\n]*)/);
    const fileName = (filenameMatch ? filenameMatch[1].replace(/['"]/g, '') : '') || 'download';
    return fileName;
}

function base64ToBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}
